import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape } from '@bibliocommons/bc-prop-types';
import { TransactionalSolidButton } from '@bibliocommons/base-buttons';

import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import accountShape from 'app/shapes/accountShape';
import { checkoutTransactionsShape } from 'app/shapes/borrowing';
import CheckoutForm from './CheckoutForm';

export default class CheckoutButton extends React.PureComponent {
  renderModal() {
    const {
      bib,
      modalKey,
      handleClose,
      digitalFormats,
      checkoutActions,
      currentAccount,
      checkoutTransactions
    } = this.props;

    return (
      currentAccount && (
        <ModalContainer modalKey={modalKey} handleClose={handleClose}>
          <CheckoutForm
            bib={bib}
            checkoutActions={checkoutActions}
            handleClose={handleClose}
            digitalFormats={digitalFormats}
            currentAccount={currentAccount}
            checkoutTransactions={checkoutTransactions}
          />
        </ModalContainer>
      )
    );
  }

  render() {
    const { disabled, handleOpen, isLoading } = this.props;

    return (
      <div className="cp-check-out-button">
        <TransactionalSolidButton block isLoading={isLoading} handleClick={handleOpen} disabled={disabled}>
          <FormattedMessage id="checkout" />
        </TransactionalSolidButton>
        {this.renderModal()}
      </div>
    );
  }
}

CheckoutButton.propTypes = {
  bib: bibShape.isRequired,
  disabled: PropTypes.bool,
  currentAccount: accountShape,
  isLoading: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  modalKey: PropTypes.string.isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  digitalFormats: ImmutablePropTypes.list.isRequired,
  checkoutTransactions: checkoutTransactionsShape.isRequired
};
